<template>
  <div class="d-grid gap-3">
    <div class="card rounded-lg border-0 shadow-sm">
      <div class="card-body p-3">
        <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
          <div>
            <p class="text-uppercase text-muted text-xxs mb-1">Report Actions</p>
            <p class="text-x fw-bold mb-1">{{ panel_title }}</p>
            <p class="text-muted text-xxs mb-0">
              Choose a saved template for the fastest route, or switch to the builder for a new setup.
            </p>
          </div>
          <div class="d-flex gap-2 flex-wrap">
            <button
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              type="button"
              @click="set_mode('template')"
            >
              Use Template
            </button>
            <button
              class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
              type="button"
              @click="set_mode('builder')"
            >
              Build New
            </button>
          </div>
        </div>
      </div>
    </div>

    <ReportTemplateLibrary
      v-if="active_mode === 'template'"
      :initial_target_entity_profile_id="initial_target_entity_profile_id"
      :subtitle="template_subtitle"
      :title="template_title"
      @generated="$emit('generated', $event)"
    />

    <ReportGenerationBuilder
      v-else
      :initial_target_entity_profile_id="initial_target_entity_profile_id"
      :initial_entity_type_id="initial_entity_type_id"
      :initial_entity_name="initial_entity_name"
    />
  </div>
</template>

<script>
import report_generation_builder_component from "@/components/probaworkflows_base_components/ReportGenerationBuilder/ReportGenerationBuilder.vue";
import report_template_library_component from "@/components/probaworkflows_base_components/ReportTemplateLibrary/ReportTemplateLibrary.vue";

export default {
  name: "ReportLaunchPanel",
  components: {
    ReportGenerationBuilder: report_generation_builder_component,
    ReportTemplateLibrary: report_template_library_component,
  },
  props: {
    initial_target_entity_profile_id: {
      type: [Number, String],
      default: null,
    },
    initial_entity_type_id: {
      type: [Number, String],
      default: null,
    },
    initial_entity_name: {
      type: String,
      default: "",
    },
  },
  emits: ["generated"],
  data: () => ({
    active_mode: "template",
  }),
  computed: {
    is_profile_scoped() {
      return Boolean(Number(this.initial_target_entity_profile_id || 0));
    },
    panel_title() {
      return this.is_profile_scoped ? "Generate for this profile" : "Generate project report";
    },
    template_title() {
      return this.is_profile_scoped ? "Profile Templates" : "Saved Templates";
    },
    template_subtitle() {
      return this.is_profile_scoped
        ? "Generate directly for this profile from a saved template, or switch to the builder for a custom one-off."
        : "Generate a project report from a saved template, or switch to the builder for a new setup.";
    },
  },
  methods: {
    set_mode(mode) {
      this.active_mode = mode;
    },
  },
};
</script>
